// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"8052e528","45":"6f7c78a3","151":"ae1a9abc","954":"1523fcad"}[chunkId] + ".chunk.js";
};